import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import Gallery from 'react-photo-gallery';
import { connect } from 'react-redux';
import classes from './Gallery.module.css';
import GalleryItem from 'components/Log/Gallery/GalleryItem/GalleryItem';
import Spinner from 'components/UI/Spinner/Spinner';
import * as actions from 'store/actions';

class GalleryMosaic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPageNumber: 1,
      // scrollSet: false,
      // newPostsLoaded: false,
      showAllImagesForPost: false,
      showViewTypeSelector: false,
      smallTilePageSize: 200,
      largeTileMorePostsPageSize: 45,
      smallTileMorePostsPageSize: 100,
      largeTilePageSize: 90,
      largeImageHeight: 225,
      smallImageHeight: 125,
    };
    this.scrollContainer = React.createRef();
  }

  componentDidMount() {
    // Fetch posts for selected logs unless the user is returning from viewing post detail
    if (this.props.filters.logIds.length > 0) {
      this.fetchInitialPosts();
    }
  }

  componentDidUpdate(prevProps) {
    // if(prevProps.currentLogs.Posts.length === 0 && this.props.currentLogs.Posts.length > 0) document.getElementById('log-container').scrollTo(0,0);

    // If user has toggled from one log to another
    // OR a user has edited/added/deleted a post
    // OR sort order or sort column has changed, fetch log
    // Or filters have been changed
    // fetch posts

    if (
      (this.props.submitted && !prevProps.submitted) ||
      prevProps.sortColumns[this.props.selectedSortColumn].sortOrder !== this.props.sortColumns[this.props.selectedSortColumn].sortOrder ||
      prevProps.selectedSortColumn !== this.props.selectedSortColumn ||
      this.props.filters !== prevProps.filters ||
      this.props.postViewSize !== prevProps.postViewSize
    ) {
      this.props.onUpdateScrollToTopOfChild(true);
      this.setState({ currentPageNumber: 1 });
      this.fetchInitialPosts(this.state.showAllImagesForPost);
    }

    if (this.props.currentLogs.Posts.length > prevProps.currentLogs.Posts.length) {
      if (this.state.loading) this.setState({ loading: false });
      // this.setState({ newPostsLoaded: true });
    }
  }

  fetchInitialPosts = (showAll) => {
    this.setState({ loading: true });
    const viewType = showAll ? 'GalleryAllImages' : null;
    const postsPerQuery = this.props.postViewSize === 'large' ? this.state.largeTilePageSize : this.state.smallTilePageSize;
    this.props.handleLogFetch(1, null, true, false, false, postsPerQuery, viewType);
  };

  fetchMorePosts = () => {
    // We only have the access to the totalPostCount (aka "PostCount") when we view 1 image per post, when using api/v2_userLogGalleryView
    // to view all images for posts, we check whether the number of returned posts is equal to the pageSize as a means of determining
    // whether there are more posts available or not
    const postsPerQuery = this.props.postViewSize === 'large' ? this.state.largeTileMorePostsPageSize : this.state.smallTileMorePostsPageSize;
    if (
      (this.props.currentLogs.PostCount > this.props.currentLogs.Posts.length ||
        (this.props.currentLogs.PostCount === undefined &&
          this.props.currentLogs.PostCountReturned !== 0 &&
          this.props.currentLogs.PostCountReturned === this.props.currentLogs.Page.PageSize)) &&
      !this.props.loading
    ) {
      const updatedPageNumber = this.state.currentPageNumber + 1;
      // const postsPerQuery = this.props.postViewSize === 'large' ? this.state.largeTilePageSize : this.state.smallTilePageSize;
      const viewType = this.state.showAllImagesForPost ? 'GalleryAllImages' : null;
      this.props.handleLogFetch(updatedPageNumber, null, true, false, false, postsPerQuery, viewType);
      this.setState({ currentPageNumber: updatedPageNumber });
    }
  };

  listenScrollEvent = () => {
    if (
      !this.props.loading &&
      this.scrollContainer.current.scrollHeight - (this.scrollContainer.current.scrollTop + this.scrollContainer.current.clientHeight) < 200
    ) {
      this.fetchMorePosts();
    }
  };

  toggleShowAllImages = (showAll) => {
    if (this.state.showAllImagesForPost !== showAll) {
      this.setState({ showAllImagesForPost: showAll, currentPageNumber: 1 });
      this.fetchInitialPosts(showAll);
    }
  };

  imageRenderer = ({ index, onClick, photo, margin }) => {
    // Potential place
    // if(index % pageSize === 0) trigger check to see whether page is filled up
    return <GalleryItem key={index} index={index} photo={photo} keyId={`photo-${photo.postDetails.PostId}`} clicked={onClick} margin={margin} />;
  };

  render = () => {
    const showOnePhotos = [];
    const showAllPhotos = [];
    if (this.props.currentLogs.Posts && this.props.currentLogs.Posts.length > 0) {
      this.props.currentLogs.Posts.forEach((post) => {
        if (this.state.showAllImagesForPost) {
          if (post.FilesGallery && post.FilesGallery.Files && post.FilesGallery.Files.length) {
            post.FilesGallery.Files.forEach((photo) =>
              showAllPhotos.push({
                src: photo.Sized1URL,
                height: 1,
                maxHeight: this.props.postViewSize === 'large' ? this.state.largeTilePageSize : this.state.smallTilePageSize,
                r: photo.r,
                width: photo.r,
                postDetails: post.Post,
                sortBy: this.props.selectedSortColumn,
                imageSize: this.props.postViewSize,
              }),
            );
          }
        } else if (
          post.Files !== undefined &&
          post.Files.FileTop !== null &&
          post.Files.FileTop.MediaType === 'Image' &&
          !this.state.showAllImagesForPost
        ) {
          showOnePhotos.push({
            src: post.Files.FileTop.Sized1URL,
            height: 1,
            maxHeight: this.props.postViewSize === 'large' ? this.state.largeTilePageSize : this.state.smallTilePageSize,
            width: post.Files.FileTop.r,
            r: post.Files.FileTop.r,
            postDetails: post.Post,
            sortBy: this.props.selectedSortColumn,
            imageSize: this.props.postViewSize,
          });
        }
      });
    }

    return (
      <div id="scrollContainer" ref={this.scrollContainer} className={classes.GalleryContainer} onScroll={this.listenScrollEvent.bind(this)}>
        <div
          className={
            this.state.showViewTypeSelector ? [classes.ShowDropdown, classes.ViewTypeSelectorContainer].join(' ') : classes.ViewTypeSelectorContainer
          }
        >
          <div className={classes.Selector}>
            <h3 onClick={() => this.setState({ showViewTypeSelector: !this.state.showViewTypeSelector })}>
              {this.state.showAllImagesForPost ? 'All Photos From Posts' : 'First Photo'}
            </h3>
            <FontAwesomeIcon icon="chevron-down" className={classes.SelectorIcon} />
          </div>
          <div className={classes.Dropdown}>
            <div onClick={() => this.toggleShowAllImages(false)} className={classes.Option}>
              <h3>Show first photo per post</h3>
              {!this.state.showAllImagesForPost ? <FontAwesomeIcon icon="check" className={classes.CheckMark} /> : null}
            </div>
            <div className={classes.Option} onClick={() => this.toggleShowAllImages(true)}>
              <h3>Show all photos per post</h3>
              {this.state.showAllImagesForPost ? <FontAwesomeIcon icon="check" className={classes.CheckMark} /> : null}
            </div>
          </div>
        </div>
        {this.state.loading && this.props.currentLogs.Posts.count === 0 ? (
          <div className={classes.SpinnerContainer}>
            <Spinner lightColor small={false} />
          </div>
        ) : null}
        <div className={classes.GalleryInnerContainer} id="gallery-container">
          {this.state.loading && this.props.currentLogs.Posts.count === 0 ? null : this.state.showAllImagesForPost ? (
            <Gallery
              onClick={this.props.handlePostSelect}
              targetRowHeight={this.props.postViewSize === 'large' ? this.state.largeImageHeight : this.state.smallImageHeight}
              margin={1}
              photos={showAllPhotos}
              renderImage={this.imageRenderer}
            />
          ) : (
            <Gallery
              onClick={this.props.handlePostSelect}
              targetRowHeight={this.props.postViewSize === 'large' ? this.state.largeImageHeight : this.state.smallImageHeight}
              margin={1}
              photos={showOnePhotos}
              renderImage={this.imageRenderer}
            />
          )}
          {this.state.loading && this.props.currentLogs.Posts.count > 0 ? (
            <div className={classes.LoadingMore}>
              <Spinner lightColor small />

              <h3>Loading...</h3>
            </div>
          ) : null}
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    logs: state.user.postingAs.Logs,
    submitted: state.post.submitted,
    currentLogs: state.logs.currentLogs,
    loading: state.logs.loading === true,
    scrollToTopOfTable: state.app.scrollToTopOfChild,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdateScrollToTopOfChild: (scrollToTop) => dispatch(actions.updateScrollToTopOfChild(scrollToTop)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GalleryMosaic);
